// biome-ignore assist/source/organizeImports: <explanation>
import "./assets/styles/reset.css";
import "uno.css";
import "../../shared/assets/styles/transitions.css";
import { PiniaColada } from "@pinia/colada";
import { createPinia } from "pinia";
import { createApp, markRaw } from "vue";
import { createRouter, createWebHistory } from "vue-router/auto";
import {
	addFeatureFlagsToRouter,
	addPageViewToRouter,
	posthogInit,
} from "../../shared/lib/posthog";
import { redirectOnUnauthenticated } from "../../shared/store/user";
import App from "./App.vue";
import { setupLayouts } from "virtual:generated-layouts";
import { sentryVue } from "../../shared/lib/sentry";
import { addPermissionsToRouter } from "./lib/router-permissions";
import { useAuth } from "./stores/auth";

posthogInit({
	denyList: ["local.adoptions.bibliu.co"],
	debug: false,
});

const app = createApp(App);
const pinia = createPinia();

const router = createRouter({
	history: createWebHistory(),
	extendRoutes: (routes) => setupLayouts(routes),
});

addFeatureFlagsToRouter(router, { redirect: "/" });
addPageViewToRouter(router);
addPermissionsToRouter(router);

pinia.use(({ store }) => {
	store.router = markRaw(router);
});

sentryVue({
	app,
	router,
	dsn: "https://20343a307954d03b717ce32fc844f053@o4508335904260096.ingest.us.sentry.io/4508439232184320",
});

app.use(router).use(pinia).use(PiniaColada).mount("#app");

// Redirect to login page if not authenticated
// prevent navigation to unauthorized pages
redirectOnUnauthenticated({
	router,
	authStore: useAuth(),
	unauthorizedRoute: "/unauthorized",
});
